import React from 'react'
import { Stack, Typography } from '@mui/material';
import Icon from '../assets/icons/gym.png';

const BodyPart = ({item,setItem}) => {

  // console.log(item) 


  return (
    <Stack direction={"row"} my="3vh">
      
    
  
            <Stack
              flexDirection={"row"}
              type="button"
              alignItems="center"
              justifyContent="center"
              className="bodyPart-card"
              sx={{ borderTop: '4px solid #FF2625', background: '#fff', borderBottomLeftRadius: '20px', width: '100%', height: '282px', cursor: 'pointer' ,mb:"25px"}}
              onClick={() => {
                setItem( item.name);
                window.scrollTo({ top: 1800, left: 100, behavior: 'smooth' });
              }}
            >

              <Stack direction={"column"} alignItems="center" >
                <img src={Icon} alt="dumbbell" style={{ width: '40px', height: '40px' }} />
                <Typography fontSize="24px" fontWeight="bold" fontFamily="Alegreya" color="#3A1212" textTransform="capitalize"> {item.name}</Typography>
              </Stack>



            </Stack>
      
      
    </Stack>

  )
}

export default BodyPart
